import { useQuery } from '@tanstack/react-query'

import { simulacaoKeys } from '@/features/simulador/brasil/utils/queries'
import { ValidarSimulacaoParaProposta } from '@/features/simulador/shared/http/validar-simulacao-para-proposta.service'

export const useValidarSimulacaoParaProposta = (simulacaoId: string) => {
  return useQuery({
    queryKey: simulacaoKeys.validarSimulacaoParaProposta(simulacaoId),
    queryFn: async () => new ValidarSimulacaoParaProposta().execute(simulacaoId).then((res) => res.data),
    enabled: false,
  })
}
